/* eslint-disable */
// @ts-nocheck

import { EventEmitter, Injectable, Output } from "@angular/core";
import { MessageService } from "@progress/kendo-angular-l10n";
import {
  deComponentMessages,
  deCustomMessages,
} from "../../assets/messages/de";
import {
  enComponentMessages,
  enCustomMessages,
} from "../../assets/messages/en-US";
import {
  frComponentMessages,
  frCustomMessages,
} from "../..//assets/messages/fr";

type ComponentMessages = Record<string, string>;

type LocaleMessages = Record<string, ComponentMessages>;

const componentMsgs: LocaleMessages = {
  ["en-US"]: enComponentMessages,
  ["fr-FR"]: frComponentMessages,
  ["de-DE"]: deComponentMessages,
};

const customMsgs: LocaleMessages = {
  ["en-US"]: enCustomMessages,
  ["fr-FR"]: frCustomMessages,
  ["de-DE"]: deCustomMessages,
};

@Injectable({
  providedIn: "root",
})
export class CustomMessagesService extends MessageService {
  @Output() public localeChange = new EventEmitter();
  private localeId = this.getLanguageFromDomain();

  public set language(value: string) {
    const locale = componentMsgs[value];
    if (locale) {
      this.localeId = value;
      this.localeChange.emit();
      this.notify();
    }
  }

  public get language(): string {
    return this.localeId;
  }

  private getLanguageFromDomain(): string {
    const hostname = window.location.hostname;

    if (hostname === "archive-ia.net" || hostname.endsWith(".archive-ia.net")) {
      return "fr-FR";
    }

    if (hostname === "archive-ai.net" || hostname.endsWith(".archive-ai.net")) {
      return "en-US";
    }

    return "en-US";
  }

  private get messages(): any {
    const messages = componentMsgs[this.localeId];
    if (messages) {
      return messages;
    }
  }

  public override get(key: string): string {
    return this.messages[key];
  }

  // Translate custom messages
  public translate(word: string): string {
    const messages = customMsgs[this.localeId];
    return messages[word];
  }
}
